module.exports = __webpack_public_path__ + "img/5-4.ba305ad5.svg";